import { render, staticRenderFns } from "./WorkClientPersonTableItem.vue?vue&type=template&id=d45667b6&scoped=true&"
import script from "./WorkClientPersonTableItem.vue?vue&type=script&lang=js&"
export * from "./WorkClientPersonTableItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkClientPersonTableItem.vue?vue&type=style&index=0&id=d45667b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45667b6",
  null
  
)

export default component.exports